/**
 * @description: Request result set
 */
export enum ResultEnum {
  SUCCESS = 'OK',
  ERROR = 1,
  TIMEOUT = 401,
  TYPE = 'success',
  USER__TEAM__NOT_EXIST = 'USER__TEAM__NOT_EXIST',
  USER__TEAM__NOT_HAVE_USER = 'USER__TEAM__NOT_HAVE_USER',
  USER__LOGIN_STATUS_TIMEOUT = 'USER__LOGIN_STATUS_TIMEOUT',
  ANNOTATION__TASK__TASK_STATUS_ERROR = 'ANNOTATION__TASK__TASK_STATUS_ERROR',
  // 团队已过期
  USER__TEAM__EXPIRED = 'USER__TEAM__EXPIRED',
  // 团队被禁用
  USER__TEAM__DISABLED = 'USER__TEAM__DISABLED',
  USER__TEAM__MEMBER_IS_FULL = 'USER__TEAM__MEMBER_COUNT_LIMIT',
  USER__STORAGE__SPACE_IS_FULL = 'USER__TEAM__STORAGE_SPACE_COUNT_LIMIT',
  USER__STORAGE__SPACE_AND_TEAM__MEMBER_IS_FULL = 'USER__TEAM_MEMBER_STORAGE_LIMIT',
  // 私有化证书过期
  LICENSE_EXPIRED = 'USER__LICENSE_EXPIRED',
}

/**
 * @description: request method
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

/**
 * @description:  contentTyp
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}
